import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
import trackVideoAnalytics from "./trackVideoAnalytics";
import { VideoAnalyticsEvent } from "./types";
var useVideoAnalytics = function useVideoAnalytics(_ref) {
  var segmentKey = _ref.segmentKey,
    enrollmentTypeKey = _ref.enrollmentTypeKey,
    courseId = _ref.courseId,
    jwtToken = _ref.jwtToken,
    lectureId = _ref.lectureId,
    hashId = _ref.hashId,
    provider = _ref.provider,
    sendErrorToSentry = _ref.sendErrorToSentry,
    playerElementRef = _ref.playerElementRef;
  var _useState = useState({
      speed: 1,
      fullscreen: false,
      quality: 'auto',
      videoDuration: 0,
      videoType: 'application/x-mpegurl'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    speed = _useState2$.speed,
    fullscreen = _useState2$.fullscreen,
    quality = _useState2$.quality,
    videoDuration = _useState2$.videoDuration,
    videoType = _useState2$.videoType,
    setState = _useState2[1];

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  var track = useCallback(function (_ref2) {
    var event = _ref2.event,
      events = _ref2.events,
      videoData = _ref2.videoData;
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _videoData$videoDurat, _videoData$quality, _videoData$videoType, _playerElementRef$cur, _playerElementRef$cur2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!event && !(events !== null && events !== void 0 && events.length))) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.next = 4;
            return trackVideoAnalytics({
              event: event,
              events: events,
              jwtToken: jwtToken,
              user: {
                segment: segmentKey,
                enrollment_type: enrollmentTypeKey
              },
              video: {
                course_id: courseId,
                original_id: lectureId,
                duration: (_videoData$videoDurat = videoData === null || videoData === void 0 ? void 0 : videoData.videoDuration) !== null && _videoData$videoDurat !== void 0 ? _videoData$videoDurat : videoDuration,
                hash_id: hashId,
                provider: provider
              },
              player: {
                name: 'crehana',
                speed: speed,
                fullscreen: fullscreen,
                quality: (_videoData$quality = videoData === null || videoData === void 0 ? void 0 : videoData.quality) !== null && _videoData$quality !== void 0 ? _videoData$quality : quality,
                type: (_videoData$videoType = videoData === null || videoData === void 0 ? void 0 : videoData.videoType) !== null && _videoData$videoType !== void 0 ? _videoData$videoType : videoType,
                width: ((_playerElementRef$cur = playerElementRef.current) === null || _playerElementRef$cur === void 0 ? void 0 : _playerElementRef$cur.offsetWidth) || 0,
                height: ((_playerElementRef$cur2 = playerElementRef.current) === null || _playerElementRef$cur2 === void 0 ? void 0 : _playerElementRef$cur2.offsetHeight) || 0
              },
              sendErrorToSentry: sendErrorToSentry
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  // Ignoring sendErrorToSentry function prop in dependency list
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [segmentKey, enrollmentTypeKey, courseId, jwtToken, lectureId, hashId, provider, speed, fullscreen, quality, videoDuration, videoType]);
  var onVideoReady = useCallback(function (videoData) {
    var qualityNumber = Number(videoData.quality);
    var data = {
      videoDuration: videoData.videoDuration || 0,
      videoType: videoData.videoType,
      quality: qualityNumber || 'auto'
    };
    track({
      event: {
        name: VideoAnalyticsEvent.PLAYER_READY,
        position: 0
      },
      videoData: data
    });
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), data);
    });
  }, [track]);
  var onSpeedChange = useCallback(function (value) {
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        speed: value
      });
    });
  }, []);
  var onFullscreenChange = useCallback(function (value) {
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        fullscreen: value
      });
    });
  }, []);
  var onQualityChange = useCallback(function (value) {
    var qualityNumber = Number(value);
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        quality: qualityNumber || 'auto'
      });
    });
  }, []);
  return {
    onSpeedChange: onSpeedChange,
    onFullscreenChange: onFullscreenChange,
    onQualityChange: onQualityChange,
    onVideoReady: onVideoReady,
    track: track
  };
};
export default useVideoAnalytics;